import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { router, routes } from "../../../app/routes";
import { useUrlParams } from "../../../hooks";
import {
  TopbarSubmenu,
  IconDefinitions,
  TopbarMenuItem,
} from "../../../components";

export const OrganizationTopbar = (props: any) => {

  const location = useLocation();

  const id = useUrlParams("id");

  const submenuItems: TopbarMenuItem[] = useMemo(
    (): TopbarMenuItem[] => [
        {
          label: "Back",
          icon: IconDefinitions.back,
          url: routes.organization.index,
        },
        {
          label: "Details",
          icon: IconDefinitions.squareInfo,
          url: routes.organization.details,
          activeMatch: routes.organization.details,
          activeMatchExact: true,
          params: new Map([["id", id]]),
        },
        {
          label: "Address",
          icon: IconDefinitions.mapMarker,
          url: routes.organization.address,
          activeMatch: routes.organization.address,
          activeMatchExact:true,
          params: new Map([["id", id]])
        },
        {
          label: "Locations",
          icon: IconDefinitions.home,
          clickHandler: () =>
            router.navigate(
              `${routes.location.index}?organizationFilterId=${id}&returnUrl=${location.pathname}`
            ),
          url: "",
        },
      ],
    [id]
  );

  return <TopbarSubmenu className="p-0" items={submenuItems} />;
};

export default OrganizationTopbar;

